/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchAccount } from "../../redux/account/account";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import DataTableTemplatingDemo from "../../components/subscription/DataTableTemplatingDemo/DataTableTemplatingDemo";
import { Link } from "react-router-dom";
import freeCountries from "../../utils/freeCountries.json";
import plansComparison from "../../constants/plansComparison.json";
import {
  CreditCard,
  Clock,
  Package,
  CheckCircle,
  XCircle,
  Clock as ClockIcon,
  Award,
  Search,
  Star,
  Zap,
  Rocket,
  Users,
  Check,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import PlansFree from "../../components/PlansFree";
import DhdCurrentPlanBanner, {
  DHD_PLAN_NAME,
} from "../../components/DhdCurrentPlanBanner";

function Subscription() {
  const transaction = useSelector((state) => state.TransactionReducer);
  const [pageSize, setPageSize] = useState(10);
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);
  const [activeTab, setActiveTab] = useState("tab1");
  const [filter, setFilter] = useState("");
  const [filter2, setFilter2] = useState("");
  const [localSub, setLocalSub] = useState(account?.subscription || null);
  const selectedCountry = store?.country || "الجزائر";
  const isAlgeria = selectedCountry === "الجزائر";
  const isFreeCountry = freeCountries.includes(account?.country);
  const digitalStore = useSelector((state) => state.digitalStoreReducer);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleDhdLocalUpdate = (nextSub) => {
    setLocalSub(nextSub);
    dispatch(
      fetchAccount({
        ...account,
        subscription: nextSub,
      }),
    );
  };

  useEffect(() => {
    if (isFreeCountry) {
      navigate("/FreeContent");
    }
  }, [isFreeCountry, navigate]);

  useEffect(() => {
    setLocalSub(account?.subscription || null);
  }, [account?.subscription]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const dateBodyTemplate = (rowData) => {
    const remainingTime = getTimeRemaining(rowData);

    if (remainingTime.totalSeconds <= 0) {
      return t("lifetime");
    }

    const { years, months, days } = remainingTime;
    let remainingString = "";

    if (years > 0) {
      remainingString += t("date.years", { count: years }) + " ";
    }

    if (months > 0) {
      remainingString += t("date.months", { count: months }) + " ";
    }

    if (days > 0) {
      remainingString += t("date.days", { count: days });
    }

    return remainingString.trim();
  };
  // for name plan getting from data
  const planKeyMap = {
    الاساسية: "basic",
    المتطورة: "advanced",
    الاسطورية: "legendary",
  };

  const currentPlan = localSub?.plan || account?.subscription?.plan;
  const planKey =
    currentPlan === DHD_PLAN_NAME
      ? t("SubscriptionSettings.plans.dhd_partnership.name")
      : planKeyMap[currentPlan] || currentPlan;

  function getTimeRemaining(rowData) {
    const totalSeconds = (new Date(rowData.seconds * 1000) - new Date()) / 1000;
    const years = Math.floor(totalSeconds / (60 * 60 * 24 * 365));
    const months = Math.floor(
      (totalSeconds % (60 * 60 * 24 * 365)) / (60 * 60 * 24 * 30),
    );
    const days = Math.floor(
      (totalSeconds % (60 * 60 * 24 * 30)) / (60 * 60 * 24),
    );
    return { totalSeconds, years, months, days };
  }

  // Map icon names to components
  const getIconComponent = (iconName, size = 18) => {
    const icons = {
      Package: <Package size={size} />,
      Rocket: <Rocket size={size} />,
      Star: <Star size={size} />,
      Award: <Award size={size} />,
    };
    return icons[iconName] || <Package size={size} />;
  };

  const plans = plansComparison.plans.map((plan) => ({
    name: t(plan.nameKey),
    desc: t(plan.descKey),
    time: t(plan.timeKey),
    price: isAlgeria ? plan.priceAlgeria : plan.priceInternational,
    isMostPop: plan.isMostPop,
    isMostPop1: plan.isMostPop1,
    icon: getIconComponent(plan.icon),
    color: plan.color,
    features: plan.features.map((featureKey) => {
      // Handle special cases with parameters
      if (featureKey === "abandoned_price") {
        return t(`SubscriptionSettings.plans.features.${featureKey}`, {
          price: isAlgeria ? `10 ${t("currency")}` : "0.04 $",
        });
      }
      return t(`SubscriptionSettings.plans.features.${featureKey}`);
    }),
  }));

  const downpage = () => {
    window.scrollTo(0, 0);
  };

  const statusFilters = [
    {
      id: "",
      label: t("SubscriptionSettings.purchase_history.filters.all"),
      icon: <Package size={16} className="ml-1" />,
      count: transaction.length,
    },
    {
      id: 1,
      label: t("SubscriptionSettings.purchase_history.filters.new"),
      icon: <Clock size={16} className="ml-1" />,
      count: transaction.filter((trans) => trans.isValid === 1).length,
    },
    {
      id: 2,
      label: t("SubscriptionSettings.purchase_history.filters.review"),
      icon: <ClockIcon size={16} className="ml-1" />,
      count: transaction.filter((trans) => trans.isValid === 2).length,
    },
    {
      id: 3,
      label: t("SubscriptionSettings.purchase_history.filters.paid"),
      icon: <CheckCircle size={16} className="ml-1" />,
      count: transaction.filter((trans) => trans.isValid === 3).length,
    },
    {
      id: 4,
      label: t("SubscriptionSettings.purchase_history.filters.rejected"),
      icon: <XCircle size={16} className="ml-1" />,
      count: transaction.filter((trans) => trans.isValid === 4).length,
    },
    {
      id: 5,
      label: t("SubscriptionSettings.purchase_history.filters.auto_accepted"),
      icon: <Zap size={16} className="ml-1" />,
      count: transaction.filter((trans) => trans.isValid === 5).length,
    },
  ];
  const isRTL = i18n.language === "ar";
  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? "rtl" : "ltr"}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("SubscriptionSettings.page_title")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-400 mb-0">
                  {t("SubscriptionSettings.page_subtitle")}
                </p>
              </div>
              <Link
                to={
                  (account.productMode ?? "classic") == "classic"
                    ? "/plan"
                    : "/digital/plan"
                }
              >
                <button className="flex items-center gap-2 bg-[#9b59bf] hover:bg-[#814a9f] text-white border-[#bc7ade] hover:border-purple-700 rounded-lg py-2 px-4 transition-colors">
                  <CreditCard size={18} />
                  <span className="mr-1">
                    {t("SubscriptionSettings.upgrade_button")}
                  </span>
                </button>
              </Link>
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="mx-3 mb-3 flex items-center justify-between">
            <div className="bg-white dark:!border-[#3c3a3d] dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden">
              <div className="flex">
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    activeTab === "tab1"
                      ? "bg-[#fcf6ff] text-[#9e68ba] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#bc7ade]"
                      : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("tab1")}
                >
                  {t("SubscriptionSettings.tabs.subscription_info")}
                </button>
                <button
                  className={`px-6 py-3 text-sm font-medium transition-colors ${
                    activeTab === "tab2"
                      ? "bg-[#fcf6ff] text-[#9e68ba] dark:text-gray-300 dark:bg-[#522868] border-b-2 border-[#bc7ade]"
                      : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#6e358c] dark:text-gray-300"
                  }`}
                  onClick={() => setActiveTab("tab2")}
                >
                  {t("SubscriptionSettings.tabs.purchase_history")}
                </button>
              </div>
            </div>
          </div>

          {/* Main Content */}
          {account.productMode === "classic" ||
          !digitalStore?.isActiveDigitalProducts ? (
            <div className="mx-3 mb-6">
              {/* Subscription Tab */}
              {activeTab === "tab1" && (
                <div className="space-y-6">
                  <DhdCurrentPlanBanner
                    accountId={account?.id}
                    userId={account?.user}
                    subscription={localSub}
                    onLocalUpdate={handleDhdLocalUpdate}
                  />
                  {/* Current Subscription */}
                  {account && (
                    <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                      <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300 mb-4 flex items-center">
                        <CreditCard size={20} className="text-[#9e68ba] ml-2" />
                        {t("SubscriptionSettings.current_plan.title")}
                        <span className="mr-3 text-sm font-normal px-3 py-1 bg-[#faf1ff] dark:!bg-[#522868] text-[#9e68ba] dark:!text-gray-300 rounded-full">
                          {account.subscription.tokens}{" "}
                          {t("SubscriptionSettings.current_plan.order")}
                        </span>
                      </h3>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                        <div className="bg-gray-50 dark:!bg-[#2a2a2a] rounded-lg p-4">
                          <p className="text-sm text-gray-500 dark:!text-gray-400 mb-1">
                            {t("SubscriptionSettings.current_plan.name")}
                          </p>
                          <div className="px-4 py-2 bg-[#faf1ff] dark:!bg-[#522868] text-[#9e68ba] dark:!text-gray-300 rounded-lg inline-block font-medium">
                            <span>{planKey}</span>{" "}
                          </div>
                        </div>

                        <div className="bg-gray-50 dark:!bg-[#2a2a2a] rounded-lg p-4">
                          <p className="text-sm text-gray-500 dark:!text-gray-400 mb-1">
                            {t("SubscriptionSettings.current_plan.end_date")}
                          </p>
                          <div className="px-4 py-2 bg-[#9b59bf] dark:!bg-[#6e358c] text-white rounded-lg inline-flex items-center">
                            <Clock size={16} className="ml-2" />
                            {dateBodyTemplate(account.subscription.endDate)}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Plans Section */}
                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                    <div className="text-center mb-8">
                      <h3 className="text-xl font-bold text-gray-800 dark:!text-gray-300 mb-2">
                        {t("SubscriptionSettings.plan.title")}
                      </h3>
                      <p className="text-gray-600 dark:!text-gray-400">
                        {t("SubscriptionSettings.plan.subtitle")}
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                      {plans.map((plan, idx) => (
                        <div
                          key={idx}
                          className={`relative bg-white dark:!bg-[#2a2a2a] rounded-xl overflow-hidden transition-all border-2 ${
                            plan.isMostPop || plan.isMostPop1
                              ? "border-[#9b59bf] shadow-md hover:shadow-lg"
                              : "border-gray-200 dark:!border-[#3c3a3d] hover:border-purple-300 hover:shadow"
                          }`}
                        >
                          {plan.isMostPop && (
                            <div className="absolute top-0 inset-x-0">
                              <div className="bg-[#9b59bf] text-white text-xs font-bold uppercase tracking-wider py-3 text-center">
                                {t("SubscriptionSettings.plan.most_popular")}
                              </div>
                            </div>
                          )}

                          {plan.isMostPop1 && (
                            <div className="absolute top-0 inset-x-0">
                              <div className="bg-amber-400 text-white text-xs font-bold uppercase tracking-wider py-3 text-center">
                                {t("SubscriptionSettings.plan.new")}
                              </div>
                            </div>
                          )}

                          <div
                            className={`p-1 ${
                              plan.isMostPop || plan.isMostPop1 ? "pt-5" : ""
                            }`}
                          >
                            <div className="p-5">
                              <div className="flex flex-row gap-x-2 items-center mb-3">
                                <div
                                  className={`rounded-lg overflow-hidden shadow-sm border-2 border-white dark:!border-[#3c3a3d] w-10 h-10 bg-[#faf1ff] dark:!bg-[#522868] ${plan.color} flex items-center justify-center mr-3`}
                                >
                                  {React.cloneElement(plan.icon, { size: 18 })}
                                </div>
                                <h3 className="text-lg font-semibold text-gray-800 dark:!text-gray-300">
                                  {plan.name}
                                </h3>
                              </div>

                              <p className="text-sm text-gray-600 dark:!text-gray-400 mb-4">
                                {plan.desc}
                              </p>

                              <div className="text-2xl font-bold text-gray-900 dark:!text-gray-200 mb-4">
                                {plan.price === 0
                                  ? t("SubscriptionSettings.plan.free")
                                  : plan.price === "-"
                                    ? t("SubscriptionSettings.plan.contact_us")
                                    : `${plan.price} ${
                                        isAlgeria ? t("currency") : "$"
                                      }`}
                                <span className="text-sm font-normal text-gray-500 dark:!text-gray-400 mr-1">
                                  {plan.price !== 0 && plan.price !== "-"
                                    ? `/${plan.time}`
                                    : ""}
                                </span>
                              </div>

                              <Link
                                to={
                                  (account.productMode ?? "classic") ==
                                  "classic"
                                    ? "/plan"
                                    : "/digital/plan"
                                }
                              >
                                <button
                                  className={`w-full py-2 px-4 rounded-lg transition-colors ${
                                    plan.isMostPop1
                                      ? "bg-amber-400 hover:bg-amber-500 text-white"
                                      : "bg-[#9b59bf] hover:bg-[#814a9f] text-white"
                                  }`}
                                  onClick={downpage}
                                >
                                  {plan.price === 0
                                    ? t("SubscriptionSettings.plan.start_free")
                                    : t(
                                        "SubscriptionSettings.plan.subscribe_now",
                                      )}
                                </button>
                              </Link>
                            </div>

                            <div className="border-t border-gray-100 dark:!border-[#3c3a3d] p-5">
                              <h4 className="font-medium text-gray-800 dark:!text-gray-300 mb-3">
                                {t("SubscriptionSettings.plan.features")}
                              </h4>
                              <ul className="space-y-2">
                                {plan.features.map((feature, featureIdx) => (
                                  <li key={featureIdx} className="flex text-sm">
                                    <Check
                                      size={16}
                                      className="text-green-500 ml-2 mt-0.5 flex-shrink-0"
                                    />
                                    <span className="text-gray-600 dark:!text-gray-400">
                                      {feature}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Comparison Table */}
                </div>
              )}

              {/* Purchases History Tab */}
              {activeTab === "tab2" && (
                <div>
                  {/* Status Filter Cards */}
                  <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 mb-4 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                    <div className="flex flex-wrap items-center gap-3">
                      {statusFilters.map((statusFilter) => (
                        <button
                          key={statusFilter.id}
                          onClick={() => setFilter2(statusFilter.id)}
                          className={`flex items-center px-3 py-2 rounded-lg border transition-colors ${
                            filter2 === statusFilter.id
                              ? "bg-[#fcf6ff] dark:!bg-[#522868] border-purple-300 dark:!border-[#bc7ade] text-[#9e68ba] dark:!text-gray-200"
                              : "border-gray-200 dark:!border-[#3c3a3d] hover:bg-gray-50 dark:hover:bg-[#2a2a2a] text-gray-700 dark:!text-gray-300"
                          }`}
                        >
                          {React.cloneElement(statusFilter.icon, {
                            className: `${
                              filter2 === statusFilter.id
                                ? "text-[#9e68ba]"
                                : "text-gray-500 dark:!text-gray-400"
                            } ml-1`,
                          })}
                          <span>{statusFilter.label}</span>
                          <span
                            className={`mr-2 px-2 py-0.5 text-xs rounded-full bg-gray-100  ${
                              filter2 === statusFilter.id
                                ? "dark:!bg-[#522868]"
                                : "dark:!bg-[#2a2a2a]"
                            } text-gray-600 dark:!text-gray-300`}
                          >
                            {statusFilter.count}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Transactions Table */}
                  <div className="bg-white rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden">
                    <DataTableTemplatingDemo
                      pageSize={pageSize}
                      filter={filter}
                      orders={
                        filter2 === ""
                          ? transaction
                          : transaction.filter(
                              (trans) => trans.isValid === filter2,
                            )
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <PlansFree />
          )}
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Subscription;
